import React from 'react';
import { Heart, Award, Users, Sparkles } from 'lucide-react';
import './About.css';
import { useSEO } from '../hooks/useSEO';

const About = () => {
  useSEO('/about');
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="hero-medium">About Tropiluxe</h1>
          <p className="body-large about-subtitle">
            Creating Unforgettable Luxury Beach Dining Experiences in Jamaica
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-padding">
        <div className="container">
          <div className="story-grid">
            <div className="story-image-wrapper">
              <img
                src="https://images.pexels.com/photos/5864598/pexels-photo-5864598.jpeg"
                alt="Beach dining setup"
                className="story-image"
              />
            </div>
            <div className="story-content">
              <h2 className="heading-1">Our Story</h2>
              <div className="story-text">
                <p className="body-regular">
                  Tropiluxe was born from a passion for creating extraordinary moments 
                  against the breathtaking backdrop of Jamaica's pristine beaches. We believe 
                  that special celebrations deserve more than the ordinary – they deserve 
                  an experience that touches the soul and creates memories that last a lifetime.
                </p>
                <p className="body-regular">
                  Our journey began with a simple vision: to transform the natural beauty 
                  of Jamaica's coastline into the perfect canvas for life's most precious 
                  moments. Whether it's a romantic proposal under the stars, a milestone 
                  birthday celebration, or an intimate family gathering, we craft each 
                  experience with meticulous attention to detail and genuine care.
                </p>
                <p className="body-regular">
                  Today, Tropiluxe stands as Jamaica's premier luxury beach dining service, 
                  trusted by couples, families, and event planners to deliver exceptional 
                  experiences that exceed expectations every single time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section section-padding-small">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Our Core Values</h2>
            <p className="body-large section-description">
              The principles that guide every experience we create
            </p>
          </div>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Heart size={32} />
              </div>
              <h3 className="heading-3">Passion</h3>
              <p className="body-regular">
                We pour our heart into every detail, treating each event as if it were 
                our own special celebration.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Award size={32} />
              </div>
              <h3 className="heading-3">Excellence</h3>
              <p className="body-regular">
                From gourmet cuisine to impeccable service, we maintain the highest 
                standards in everything we do.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Users size={32} />
              </div>
              <h3 className="heading-3">Personalization</h3>
              <p className="body-regular">
                Every client is unique, and we customize each experience to reflect 
                your personal style and vision.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Sparkles size={32} />
              </div>
              <h3 className="heading-3">Sustainability</h3>
              <p className="body-regular">
                We're committed to protecting Jamaica's natural beauty through 
                eco-conscious practices and responsible tourism.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="commitment-section section-padding-small">
        <div className="container">
          <div className="commitment-content">
            <h2 className="heading-1">Our Commitment to You</h2>
            <div className="commitment-text">
              <p className="body-large">
                At Tropiluxe, we understand that you're not just booking a dinner – 
                you're investing in a memory that will be cherished for years to come. 
                That's why we go above and beyond to ensure every aspect of your 
                experience is flawless.
              </p>
              <p className="body-large">
                From the moment you reach out to us until the last candle is extinguished 
                on the beach, our dedicated team works tirelessly to bring your vision 
                to life. We handle every detail with care, allowing you to relax and 
                fully immerse yourself in the magic of the moment.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;